/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import*as t from"react";import{useContext as r,useMemo as o}from"react";import{MotionConfigContext as i}from"../../context/MotionConfigContext.js";import{loadExternalIsValidProp as e}from"../../render/dom/utils/filter-props.js";import{useConstant as n}from"../../utils/use-constant.js";function s({children:s,isValidProp:m,...a}){m&&e(m),(a={...r(i),...a}).isStatic=n((()=>a.isStatic));const c=o((()=>a),[JSON.stringify(a.transition),a.transformPagePoint,a.reducedMotion]);return t.createElement(i.Provider,{value:c},s)}export{s as MotionConfig};
//# sourceMappingURL=index.js.map
